import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/components/layout/index.vue'

import { commonStore } from '@/stores/common'

import { getAccessToken, removeAccessToken } from '@/utils/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: {
      noLogin: true,
    },
    component: () => import(/* webpackChunkName: "login" */'@/views/login/index.vue'),
  },
  {
    path: '/password-login',
    name: 'PasswordLogin',
    meta: {
      noLogin: true,
    },
    component: () => import(/* webpackChunkName: "login" */'@/views/login/index.vue'),
  },
  {
    path: '/password-forgetting',
    name: 'PasswordForgetting',
    meta: {
      noLogin: true,
    },
    component: () => import(/* webpackChunkName: "login" */'@/views/login/password-forget/index.vue'),
  },
  {
    path: '/personal-center',
    name: 'PersonalCenter',
    meta: {
      noPermission: true,
    },
    component: () => import('@/views/personal-center/index.vue'),
  },
  // {
  //   path: "/password-setting",
  //   name: "PasswordSetting",
  //   parentName: "1-login"
  // },
  // {
  //   path: "/company-selection",
  //   name: "CompanySelection",
  //   parentName: "1-login"
  // },

  // {
  //   path: "/personal-information",
  //   name: "PersonalInformation",
  //   parentName: "2-home",
  //   meta: {
  //     noPermission: true
  //   }
  // },
  {
    path: '/',
    name: 'Index',
    redirect: '/company-permission-management',
    component: Layout,
    children: [
      {
        path: '/company-permission-management',
        name: 'CompanyPermissions',
        component: () => import('@/views/customer/company-permission/index.vue'),
      },
      {
        path: '/appeal-management',
        name: 'Appeal',
        component: () => import(/* webpackChunkName: "appeal-management" */'@/views/feedback/appeal/index.vue'),
      },
      {
        path: '/app-management',
        name: 'AppManagement',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/app/index.vue'),
      },
      {
        path: '/product-management',
        name: 'ProductManagement',
        parentName: 'things-management',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/product/index.vue'),
      },
      {
        path: '/product-detail',
        name: 'ProductDetail',
        parentName: 'things-management',
        meta: {
          noPermission: true,
          resourceUrl: '/product-management',
        },
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/detail/index.vue'),
        children: [],
      },
      { // 数据迁移校验
        path: '/feedback-management',
        name: 'FeedbackManagement',
        parentName: 'things-management',
        component: () => import(/* webpackChunkName: "things-management" */ '@/views/things/feedback/index.vue'),
      },
      {
        path: '/role-management',
        name: 'RoleManagement',
        component: () => import(/* webpackChunkName: "system-management" */'@/views/system/role/index.vue'),
        children: [],
      },
      {
        path: '/user-management',
        name: 'UserManagement',
        component: () => import(/* webpackChunkName: "system-management" */'@/views/system/user/index.vue'),
        children: [],
      },
      {
        path: '/device-management',
        name: 'DeviceManagement',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/device/index.vue'),
        children: [],
      },
      {
        path: '/device-detail',
        name: 'DeviceDetail',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/device-detail/index.vue'),
        children: [],
        meta: {
          noPermission: true,
          resourceUrl: '/device-management',
        },
      },
      {
        path: '/sim-card-match',
        name: 'Sim',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/sim-card-match/index.vue'),
        children: [],
      },
      {
        path: '/abnormal-data-analyze',
        name: 'Abnormal',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/abnormal-data-analyze/index.vue'),
        children: [],
      },
      {
        path: '/ota_upgrade',
        name: 'Ota',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/ota/list/index.vue'),
        children: [],
      },
      {
        path: '/ota-detail/:id',
        name: 'OtaDetail',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/ota/ota-detail/index.vue'),
        children: [],
        meta: {
          noPermission: true,
          resourceUrl: '/ota_upgrade',
        },
      },
      {
        path: '/ota-detail/sub-scribe/sub-scribe-detail/:batchNo',
        name: 'subScribeDetail',
        component: () => import(/* webpackChunkName: "things-management" */ '@/views/things/ota/ota-detail/sub-scribe/sub-scribe-detail/index.vue'),
        props: true, // 路由组件配置props
        children: [],
        meta: {
          name: '批次管理-详情',
          noPermission: true,
          resourceUrl: '/ota_upgrade',
        },
      },
      {
        path: '/operation-log',
        name: 'OperationLog',
        component: () => import(/* webpackChunkName: "system-management" */'@/views/system/operation-log/index.vue'),
        children: [],
      },
      {
        path: '/category-management',
        name: 'CategoryManagement',
        component: () => import(/* webpackChunkName: "things-management" */'@/views/things/category/index.vue'),
        parentName: 'things-management',
      },
    ],
  },
]
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// router.beforeEach(async (to, from) => {
//   const common = commonStore()
//   console.log('to', to)
//   console.log('from', from)
//   console.log('matched', to.matched)
//   if (!to.matched.length) return '/' // 未找到匹配路由
//   const hasToken = getToken()?.access_token
//   const isFirst = getToken()?.isFirst
//   // const hasPassword = getToken()?.password
//   const hasCompanyId = getCompanyId()
//   const loginPath = ['/password-login', '/verification-code-login']
//   // const { fullPath, meta, path } = to
//   const { meta, path } = to

//   if (!hasToken) { // 未登录，不需要登录的直接跳转，需要登录的跳转到登录
//     // if (from.fullPath === '/password-forgetting') return false
//     // return meta.noLogin ? true : `/password-login?redirect=${encodeURIComponent(fullPath)}`
//     return meta.noLogin ? true : '/password-login'
//   }
//   if (!hasCompanyId)
//     if (from.fullPath === '/personal-center') return false

//   if (hasCompanyId && !isFirst) { // 已经登录的场景
//     const isPermission = await hasPermission(path, meta.noPermission)
//     const isLoginPath = loginPath.includes(path)
//     console.log('开始跳转', isPermission && !isLoginPath ? true : common.firstRouter)
//     return isPermission && !isLoginPath ? true : common.firstRouter
//   }

//   // if (to.path !== '/password-setting')
//   //   user.logout() // 清空缓存
//   return true
// })

router.beforeEach(async (to, from) => {
  console.log('to', to)
  console.log('from', from)
  const common = commonStore()
  if (!to.matched.length) return '/' // 未找到匹配路由
  const hasToken = getAccessToken()
  // if (!to.matched.length) return "/" // 未找到匹配路由
  const { meta, path } = to
  if (path === '/password-login') removeAccessToken()
  if (!hasToken) {
    // 未登录，不需要登录的直接跳转，需要登录的跳转到登录
    return meta.noLogin ? true : 'password-login'
  } else {
    const isPermission = await hasPermission(path, meta.noPermission)
    const isLoginPath = path === '/password-login'
    return isPermission && !isLoginPath ? true : common.firstRouter
  }
})

router.afterEach((to) => {
  const { path, meta } = to
  const common = commonStore()
  common.activeResourceUrl = meta.resourceUrl as string || path
  common.activeRouterIdList = (common.routerList || []).filter(item => item.resourceUrl === path).map(item => item.resourceId)
})

router.onError((error, to, from) => {
  console.log('error', error)
  console.log('to', to)
  console.log('from', from)
  if (error && (/.Failed to fetch./g.test(error) || /Loading .*failed/g.test(error))) {
    ElMessage({
      message: '页面已过期，请刷新重试',
      type: 'warning',
    })
    // setTimeout(() => {
    //   window.location.reload()
    // }, 3000)
  }
})

async function hasPermission(path: string, noPermission: boolean | undefined): Promise<boolean> {
  const common = commonStore()
  if (!common.permissionList) {
    try {
      await common.queryPermission()
    } catch (error) {
      console.log('error', error)
    }
  }
  // return noPermission || (common.routerList || []).map(item => item.resourceUrl).some(resourceUrl => path.includes(resourceUrl))
  return noPermission || (common.routerList || []).map(item => item.resourceUrl).some(resourceUrl => path === resourceUrl)
}

export default router
